import { createSelector } from '@reduxjs/toolkit'
import {
  getResponse,
  getResponsesByAssignment,
} from '../../getters/entities/responses'

export const selectResponse = createSelector(
  [getResponse],
  (response) => response
)

export const selectResponsesByAssignment = createSelector(
  [getResponsesByAssignment],
  (responses) => (responses.length ? responses : null)
)
